import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTickEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	style: { enableBackground: "new 0 0 17 17" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#EBEEF0;}\n	.st1{fill:#C6CDD3;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		className: "st0",
		width: 15,
		height: 15
	}), /* @__PURE__ */ _jsx("path", {
		className: "st1",
		d: "M17,17H0V0h17V17z M2,15h13V2H2V15z"
	})] })]
});
export default SvgIcTickEmpty;
